import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Rules & Regulations</h1>
      <p>
        Welcome to <strong>Radical Sports India</strong>. These rules are established to maintain a safe, respectful, and professional sports environment for all students and guardians. By enrolling in our programs, you agree to comply with the following regulations.
      </p>

      <h2>1. Fee Payment</h2>
      <ul>
        <li>Fees must be paid in advance along with the admission form.</li>
        <li>All payments are due <strong>on or before the 10th of every month</strong>.</li>
        <li>A late fine of ₹200 will apply for delayed payments. This amount is utilized to support underprivileged children in accessing training.</li>
        <li>All fees are <strong>non-refundable</strong>, including in cases of absenteeism, holidays, or personal withdrawals.</li>
      </ul>

      <h2>2. Safety Gear</h2>
      <ul>
        <li><strong>Wearing a helmet, guard set, and academy uniform is mandatory</strong> for all participants.</li>
        <li>Students arriving without full safety gear will not be allowed to join the session.</li>
      </ul>

      <h2>3. Session Conduct</h2>
      <ul>
        <li>Parents and guardians must <strong>not interfere</strong> with the sessions or enter the training area.</li>
        <li>Only registered students and authorized staff are permitted on the skating floor.</li>
        <li>All students must maintain discipline and follow instructions from coaches strictly.</li>
      </ul>

      <h2>4. Public Holidays & Missed Classes</h2>
      <ul>
        <li>Classes will not be held on government-declared public holidays.</li>
        <li>Missed sessions will not be refunded or compensated.</li>
      </ul>

      <h2>5. Safety Disclaimer</h2>
      <p>
        Parents are responsible for their child's safety before and after the session. <strong>Radical Sports India is not liable</strong> for any injury, accident, or incident that occurs during or outside the training hours.
      </p>

      <h2>6. Training Venue</h2>
      <p>
        Training sessions are conducted at our registered center:
      </p>
      <ul>
        <li>Radical Sports Academy, 2nd Floor, Ajanta Shopping Centre, 225, Daftary Road, opp. Surbhi Sweets, near Railway Station, Malad East, Mumbai, Maharashtra 400097</li>
      </ul>

      <h2>7. Policy Updates</h2>
      <p>
        Radical Sports India reserves the right to update these rules and regulations at any time. Any updates will be communicated via registered email or in-session notices.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        For queries or clarification, please get in touch with us:
      </p>
      <ul>
        <li><strong>Email:</strong> Info@radicalsportsindia.com</li>
        <li><strong>Phone:</strong> +91 76546 4545</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
